import accessibilityAriaEnum from "../enums/accessibilityAriaEnum";

export const getAllParams = (params) => {
    const newParams = { ...params };

    Object.keys(accessibilityAriaEnum).forEach(key => {
        if (params[key]) {
            newParams[accessibilityAriaEnum[key]] = params[key];
            delete newParams[key];
        }
        else if (params.hasOwnProperty(key)) {
            delete newParams[key];
        }
    });

    return newParams;
};
